//common
import { setSmoothScroll } from './common/setSmoothScroll';
import { setMatchHeight } from './common/setMatchHeight';

//module
import { setSwiper } from './modules/setSwiper';
import { setBgImage } from './modules/setBgImage';
import { copyElem } from './modules/copyElem';
import { setAccordion } from './modules/setAccordion';
import { setModal } from './modules/setModal';
import { setHeader } from './modules/setHeader';
import { setTab } from './modules/setTab';
import { setAos } from './modules/setAos';
import { setPageTransition } from './modules/setPageTransition';
import { setOpeningLogo } from './modules/setOpeningLogo';
import { reservation } from './modules/reservation';
import { setForm } from './modules/setForm';
import { getSiteId } from './modules/getSiteId';
import { addFirstLayerUrl } from './modules/addFirstLayerUrl';
import { setExternalLink } from './modules/setExternalLink';
import { setWpReserveLink } from './modules/setWpReserveLink';
import { loadcms } from './modules/loadcms';
import { OmotenashiContents } from './modules/OmotenashiContents';

setSmoothScroll();
setMatchHeight();
setSwiper();
setBgImage();
copyElem();
setAccordion();
setModal();
setHeader();
setAos();
setTab();
setOpeningLogo();
reservation();
setForm();
getSiteId();
loadcms();
setWpReserveLink();
addFirstLayerUrl();
setExternalLink();
setPageTransition();
OmotenashiContents();
